import React, { Component } from "react";
import { connect } from "react-redux";
import { Panel, PanelContent, PanelHeader } from "../../shared/Panel";
import { withRouter } from "react-router";

import SmartExtractHeader from "../components/smart-extract/SmartExtractHeader";
import SmartExtractFilter from "../components/smart-extract/filter/SmartExtractFilter";

class SmartExtract extends Component {
	constructor() {
		super();
		this.state = {};
	}

	render() {
		return (
			<div className="offers-smart-extract">
				<Panel>
					<PanelHeader className="offers-smart-extract__panel-header">
						<SmartExtractHeader />
					</PanelHeader>

					<PanelContent>
						<SmartExtractFilter />
					</PanelContent>
				</Panel>
			</div>
		);
	}
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => {
	return {};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SmartExtract));
